var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3544",
    "data-name": "Rectangle 3544",
    width: 11,
    height: 14,
    transform: "translate(0 -0.098)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10441",
    "data-name": "Group 10441",
    transform: "translate(0 0.098)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10440",
    "data-name": "Group 10440",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27758",
    "data-name": "Path 27758",
    d: "M5.561,0A5.56,5.56,0,0,0,0,5.506c0,3.809,4.9,8.048,5.108,8.229a.7.7,0,0,0,.9,0c.243-.181,5.108-4.42,5.108-8.229A5.56,5.56,0,0,0,5.561,0m0,12.269C4.4,11.165,1.39,8.1,1.39,5.506a4.17,4.17,0,1,1,8.341,0c0,2.571-3.008,5.659-4.17,6.763",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27759",
    "data-name": "Path 27759",
    d: "M5.808,3A2.433,2.433,0,1,0,8.241,5.433,2.434,2.434,0,0,0,5.808,3m0,3.475A1.043,1.043,0,1,1,6.85,5.433,1.043,1.043,0,0,1,5.808,6.475",
    transform: "translate(-0.247 -0.22)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location-icon.28786e71c572ade8b09255dbbf2d6667.svg";
export { ForwardRef as ReactComponent };